import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
  data: {
    [index: string]: ModalData;
  };
}

interface ModalData {
  open?: boolean;
}

const initialState: ModalState = { data: {} } satisfies ModalState;
const modalSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    setModalOpen(state, action: PayloadAction<{ name: string; value: boolean }>) {
      if (state.data[action.payload.name] === undefined) {
        state.data[action.payload.name] = { open: false };
      }
      state.data[action.payload.name].open = action.payload.value;
    }
  },
  selectors: {
    selectModalOpen: (state, modal: string): boolean => {
      return state.data[modal]?.open === true;
    }
  }
});

export const { setModalOpen } = modalSlice.actions;
export const { selectModalOpen } = modalSlice.selectors;
export default modalSlice.reducer;
